import { isUndefined } from 'lodash';

import ContentManager from '../ContentManager';

function getRTLValue(value, rtlValue) {
  if (!isUndefined(rtlValue)) {
    return ContentManager.isRTL ? rtlValue : value;
  }

  return (ContentManager.isRTL ? -1 : 1) * value;
}

export { getRTLValue }; // eslint-disable-line import/prefer-default-export
